import axios from "axios";
import {GET_STATES_URL} from "../../../services/apis/StatesUrl";
import {GET_STATES} from "../../../services/types/StatesTypes";
import {toast} from "react-toastify";

export const getStates = () => async dispatch => {

    try {

        const response = await axios.get('https://nigerian-states-info.herokuapp.com/api/v1/states');
        console.log(response.data)

        if (response.data.data.length) {
            dispatch({

            type: GET_STATES,
            payload: response.data.data

        })
       }

    } catch (e) {

        toast.info("Something went wrong while fetching states, Please try again later")

    }

};